import script from "./ChildNav.vue?vue&type=script&setup=true&lang=js"
export * from "./ChildNav.vue?vue&type=script&setup=true&lang=js"

import "./ChildNav.vue?vue&type=style&index=0&id=4b243708&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b243708"]])

export default __exports__